









import mixins from 'vue-typed-mixins';
import Report from '@/components/survey/report/Report.vue';
import { Survey, QuestionParticipation } from '@/utils/SurveyUtils';
import deepEqual from 'deep-equal';
import { ReportStore, ReportVM } from '@/utils/ReportUtils';
export default mixins().extend({
  components: {
    Report,
  },

  props: {
    value: {
      type: Object as () => Survey,
    },
  },

  computed: {
    path: {
      get(): number[] {
        if (this.$route.params.path) {
          return this.$route.params.path
            .split('-')
            .map((element) => parseInt(element) - 1)
            .filter((element) => !isNaN(element));
        } else {
          return [];
        }
      },
      async set(path: number[]) {
        if (!deepEqual(this.path, path)) {
          await this.$router.push({
            name: 'survey-edit-preview',
            params: {
              ...this.$route.params,
              path: path?.map((index) => index + 1).join('-'),
            },
          });
        }
      },
    },
  },

  beforeMount() {
    ReportStore.mode = ['preview'];
    ReportStore.path = this.path;
    ReportStore.survey = this.value;
  },

  destroyed() {
    ReportVM.clear();
  },

  watch: {
    path() {
      ReportStore.path = this.path;
    },
  },
});
